import React, { useEffect, useState } from "react";
import axios from "axios";

const API_PHONE = "https://royaleva.hxbindia.com/phones";
const API_EMAIL = "https://royaleva.hxbindia.com/emails";
const API_ADDRESS = "https://royaleva.hxbindia.com/addresses";

function Contact() {
  // States for each collection
  const [phones, setPhones] = useState([]);
  const [emails, setEmails] = useState([]);
  const [addresses, setAddresses] = useState([]);

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  const [editPhoneId, setEditPhoneId] = useState(null);
  const [editEmailId, setEditEmailId] = useState(null);
  const [editAddressId, setEditAddressId] = useState(null);

  // Fetch all data
  const fetchAll = async () => {
    try {
      setPhones((await axios.get(API_PHONE)).data);
      setEmails((await axios.get(API_EMAIL)).data);
      setAddresses((await axios.get(API_ADDRESS)).data);
    } catch (err) {
      console.log("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  // ---------------- PHONE ----------------
  const savePhone = async (e) => {
    e.preventDefault();

    try {
      if (editPhoneId) {
        await axios.put(`${API_PHONE}/${editPhoneId}`, { phone });
      } else {
        await axios.post(API_PHONE, { phone });
      }
      setPhone("");
      setEditPhoneId(null);
      fetchAll();
    } catch (err) {
      console.log("Phone save error:", err);
    }
  };

  const deletePhone = async (id) => {
    if (!window.confirm("Delete this phone?")) return;
    await axios.delete(`${API_PHONE}/${id}`);
    fetchAll();
  };

  // ---------------- EMAIL ----------------
  const saveEmail = async (e) => {
    e.preventDefault();

    try {
      if (editEmailId) {
        await axios.put(`${API_EMAIL}/${editEmailId}`, { email });
      } else {
        await axios.post(API_EMAIL, { email });
      }
      setEmail("");
      setEditEmailId(null);
      fetchAll();
    } catch (err) {
      console.log("Email save error:", err);
    }
  };

  const deleteEmail = async (id) => {
    if (!window.confirm("Delete this email?")) return;
    await axios.delete(`${API_EMAIL}/${id}`);
    fetchAll();
  };

  // ---------------- ADDRESS ----------------
  const saveAddress = async (e) => {
    e.preventDefault();

    try {
      if (editAddressId) {
        await axios.put(`${API_ADDRESS}/${editAddressId}`, { address });
      } else {
        await axios.post(API_ADDRESS, { address });
      }
      setAddress("");
      setEditAddressId(null);
      fetchAll();
    } catch (err) {
      console.log("Address save error:", err);
    }
  };

  const deleteAddress = async (id) => {
    if (!window.confirm("Delete this address?")) return;
    await axios.delete(`${API_ADDRESS}/${id}`);
    fetchAll();
  };

  return (
    <div className="container mt-5">

      <h2 className="text-center">📞 Contact Settings (Separate Collections)</h2>
      <hr />

      {/* PHONE SECTION */}
      <h4>📱 Phone Numbers</h4>
      <form onSubmit={savePhone} className="row g-3 mb-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Enter phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" type="submit">
            {editPhoneId ? "Update" : "Add"}
          </button>
        </div>
      </form>

      <table className="table table-striped table-bordered mb-5">
        <thead className="table-dark">
          <tr>
            <th>Phone</th>
            <th width="150">Actions</th>
          </tr>
        </thead>
        <tbody>
          {phones.length === 0 ? (
            <tr><td colSpan="2" className="text-center">No Phones</td></tr>
          ) : (
            phones.map((p) => (
              <tr key={p._id}>
                <td>{p.phone}</td>
                <td>
                  <button className="btn btn-warning btn-sm me-2"
                    onClick={() => { setPhone(p.phone); setEditPhoneId(p._id); }}>
                    Edit
                  </button>
                  <button className="btn btn-danger btn-sm"
                    onClick={() => deletePhone(p._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* EMAIL SECTION */}
      <h4>📧 Emails</h4>
      <form onSubmit={saveEmail} className="row g-3 mb-3">
        <div className="col-md-4">
          <input
            type="email"
            className="form-control"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" type="submit">
            {editEmailId ? "Update" : "Add"}
          </button>
        </div>
      </form>

      <table className="table table-striped table-bordered mb-5">
        <thead className="table-dark">
          <tr>
            <th>Email</th>
            <th width="150">Actions</th>
          </tr>
        </thead>
        <tbody>
          {emails.length === 0 ? (
            <tr><td colSpan="2" className="text-center">No Emails</td></tr>
          ) : (
            emails.map((e) => (
              <tr key={e._id}>
                <td>{e.email}</td>
                <td>
                  <button className="btn btn-warning btn-sm me-2"
                    onClick={() => { setEmail(e.email); setEditEmailId(e._id); }}>
                    Edit
                  </button>
                  <button className="btn btn-danger btn-sm"
                    onClick={() => deleteEmail(e._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* ADDRESS SECTION */}
      <h4>📍 Addresses</h4>
      <form onSubmit={saveAddress} className="row g-3 mb-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Enter address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" type="submit">
            {editAddressId ? "Update" : "Add"}
          </button>
        </div>
      </form>

      <table className="table table-striped table-bordered">
        <thead className="table-dark">
          <tr>
            <th>Address</th>
            <th width="150">Actions</th>
          </tr>
        </thead>
        <tbody>
          {addresses.length === 0 ? (
            <tr><td colSpan="2" className="text-center">No Addresses</td></tr>
          ) : (
            addresses.map((a) => (
              <tr key={a._id}>
                <td>{a.address}</td>
                <td>
                  <button className="btn btn-warning btn-sm me-2"
                    onClick={() => { setAddress(a.address); setEditAddressId(a._id); }}>
                    Edit
                  </button>
                  <button className="btn btn-danger btn-sm"
                    onClick={() => deleteAddress(a._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

    </div>
  );
}

export default Contact;
